export const shipping = () => {
	const shippingButtons = document.getElementsByClassName('shipping_method');

	const updateShippingMethodsBlock = (e) => {
		for ( let i = 0; i < shippingButtons.length; i++ ) {
			shippingButtons.item(i).parentElement.parentElement.classList.remove('active');
		}

		e.target.parentElement.parentElement.classList.add('active');
	}

	for ( let i = 0; i < shippingButtons.length; i++ ) {
		if(shippingButtons.item(i).checked) {
			shippingButtons.item(i).parentElement.parentElement.classList.add('active');
		}

		shippingButtons.item(i).onclick = updateShippingMethodsBlock;
	}
}
